import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPluralsightComponent } from './simple-icons-pluralsight.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPluralsightComponent ],
    exports:      [ SimpleIconsPluralsightComponent ],
    bootstrap:    []
})
export class SimpleIconsPluralsightModule {}
